module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_m_normal.3723f5a8.png";